module.exports = __webpack_public_path__ + "assets/img/home-zgyd.580a0def.png";